module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a1db95304722ee4bb6b7df7c49b563fc.png";